import "react";
import { FormLayout, HTMLSelect, Textarea } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/InfoBlock/Config.tsx
var InfoBlockFieldConfig = ({ config, setOptions, setOptionsKey }) => {
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(FormLayout, {
		space: "sm",
		children: [/* @__PURE__ */ jsx(Textarea, {
			onChangeValue: (value) => setOptionsKey("body", value),
			label: "Description",
			value: config.options.body
		}), /* @__PURE__ */ jsx(HTMLSelect, {
			label: "Style",
			onChangeValue: (value) => setOptionsKey("bgStyle", value),
			options: [
				{
					label: "info",
					value: "info"
				},
				{
					label: "neutral",
					value: "neutral"
				},
				{
					label: "positive",
					value: "positive"
				},
				{
					label: "caution",
					value: "caution"
				},
				{
					label: "critical",
					value: "critical"
				}
			],
			value: config.options.bgStyle
		})]
	}) });
};
//#endregion
export { InfoBlockFieldConfig };

//# sourceMappingURL=Config.js.map